import {z} from 'zod'

/**
 * API response shapes for the referential.
 *
 * Validated at the service level rather than trusted: a label whose `segments`
 * silently arrived as `undefined` would crash the expansion panel far from the
 * request that caused it.
 */

export const TrackSegmentSchema = z.object({
  id: z.string(),
  trackId: z.string(),
  kmStart: z.number(),
  kmEnd: z.number(),
  direction: z.string(),
})

export const NetworkTrackLabelSchema = z.object({
  id: z.string(),
  networkId: z.string(),
  name: z.string(),
  acronym: z.string().nullable(),
  isMain: z.boolean(),
  segments: z.array(TrackSegmentSchema).default([]),
})

export const NetworkTrackLabelListSchema = z.array(NetworkTrackLabelSchema)

// A zero-length segment describes no geometry and would drop out of every km
// lookup instead of failing — the API refuses it too.
export const TrackSegmentFormSchema = z
  .object({
    kmStart: z.number(),
    kmEnd: z.number(),
    direction: z.enum(['ASC', 'DESC']),
  })
  .refine(s => s.kmStart !== s.kmEnd, {
    message: 'error:fieldRequired',
    path: ['kmEnd'],
  })

export const SwitchConnectionFormSchema = z.object({
  name: z.string().nullable().optional(),
  trackAId: z.string().min(1),
  pkA: z.number(),
  trackBId: z.string().min(1),
  pkB: z.number(),
  type: z.number(),
  isActive: z.boolean(),
})
